export enum ScenarioUpdateEnum {
  RENAME,
}
